module.exports = __webpack_public_path__ + "img/Arrow_Box_Left_Green.0e63318f.svg";